@if (visible()) {
  <div class="consent-lock-banner d-flex align-items-center gap-3" role="status">
    <mat-icon class="consent-lock-banner__icon flex-shrink-0">lock</mat-icon>
    <p class="consent-lock-banner__text mb-0 flex-grow-1">
      {{ 'app.consentLock.banner.message' | translate }}
    </p>
    <button
      mat-stroked-button
      class="consent-lock-banner__action px-4 rounded-full flex-shrink-0"
      (click)="onReturnToConsent()"
    >
      {{ 'app.consentLock.banner.action' | translate }}
    </button>
  </div>
}
